import { Component, OnInit } from '@angular/core';
import { fadeInOut } from '../../shared/helpers/animations';
import { StorageManagerService } from '../../shared/services/index';

@Component({
	selector: 'app-support',
	templateUrl: './support.component.html',
	styleUrls: ['./support.component.css'],
	animations: [fadeInOut]
})
export class SupportComponent implements OnInit {

	constructor (private storage: StorageManagerService) { }

	ngOnInit() {

    this.storage.write('activeTab', 'device');
    
    // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

}
